<template>
  <div class="container">
    <h2 class="section-title">项目案例</h2>
    <p class="section-sub">卓越实践，见证智慧手术室变革</p>
    <div class="grid-3">
      <div v-for="item in caseList" :key="item.id" class="card" @click="$router.push(item.link)">
        <img :src="item.img" :alt="item.title">
        <div class="card-body">
          <h3>{{ item.title }}</h3>
          <p>{{ item.summary }}</p>
          <span class="more">查看详情 →</span>
        </div>
      </div>
    </div>

    <div class="spacing-section"></div>

    <!-- 项目案例横幅 -->
    <div class="cases-banner">
      <div class="banner-content">
        <h1 class="banner-title">智慧手术室解决方案</h1>
        <p class="banner-subtitle">全国100+医院信赖选择，见证医疗数字化转型</p>
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">100+</div>
            <div class="stat-label">合作医院</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">50+</div>
            <div class="stat-label">专利技术</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">10000</div>
            <div class="stat-label">生产面积(㎡)</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">30%</div>
            <div class="stat-label">成本节约</div>
          </div>
        </div>
        <p class="banner-desc">爱谱乐医疗深耕智慧手术室领域，为全国各大医院提供专业的手术室行为管理、麻醉药品管理、耗材管理系统解决方案，助力医院实现数字化、智能化转型。</p>
      </div>
      <div class="banner-image">
        <img src="https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80" alt="智慧手术室解决方案">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      caseList: [
        { id: 'national-child', title: '国家儿童医学中心', summary: '智慧手术部系统建设标杆，围术期临床数据中心+自动化管控', img: 'https://picsum.photos/id/101/400/260', link: '/cases/national-child' },
        { id: 'renji', title: '上海交通大学医学院附属仁济医院', summary: '手术室行为管理+毒麻药柜，全院智慧物资升级', img: 'https://picsum.photos/id/164/400/260', link: '/cases/renji' },
        { id: 'west-china', title: '华西医院手术平台', summary: '耗材SPD+智能柜，降低运营成本超30%', img: 'https://picsum.photos/id/186/400/260', link: '/cases/west-china' }
      ]
    };
  },
  mounted() {
    // 添加滚动动画效果
    this.$nextTick(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      });

      const elements = document.querySelectorAll('.stat-item, .card');
      elements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = 'all 0.6s ease';
        observer.observe(el);
      });
    });
  }
};
</script>

<style scoped>
.container { max-width: 1280px; margin: 0 auto; padding: 48px 24px; }

.spacing-section {
  height: 60px;
}

/* 项目案例横幅 */
.cases-banner {
  background: linear-gradient(135deg, #0f5c6e 0%, #1f8aad 50%, #2c9cc5 100%);
  border-radius: 32px;
  padding: 60px 40px;
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  gap: 40px;
  color: white;
  box-shadow: 0 20px 40px rgba(31, 138, 173, 0.2);
}

.banner-content {
  flex: 1;
}

.banner-title {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
}

.banner-subtitle {
  font-size: 20px;
  margin-bottom: 32px;
  opacity: 0.9;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.8;
}

.banner-desc {
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.9;
}

.banner-image {
  flex: 0 0 300px;
}

.banner-image img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0,0,0,0.2);
}

.section-title { font-size: 32px; font-weight: 700; text-align: center; margin-bottom: 16px; color: #0f2b36; }
.section-sub { text-align: center; color: #4b5563; max-width: 700px; margin: 0 auto 40px; }
.grid-3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 32px; }
.card { background: white; border-radius: 24px; overflow: hidden; box-shadow: 0 8px 20px rgba(0,0,0,0.05); cursor: pointer; transition: 0.3s; }
.card:hover { transform: translateY(-5px); }
.card img { width: 100%; height: 200px; object-fit: cover; }
.card-body { padding: 20px; }
.card-body h3 { margin-bottom: 12px; }
.card-body p { color: #4b5563; margin-bottom: 12px; }
.more { color: #1f8aad; font-weight: 500; }
</style>